module.exports = __webpack_public_path__ + "img/logo.5961c272.jpg";